
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdModeEdit } from "react-icons/md";

import './Routermodelselling.css'; // Assuming you have a CSS file for styling  

export const Routermodelselling = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editedCost, setEditedCost] = useState("");

    const [routerTypes, setRouterTypes] = useState([]);

useEffect(() => {
  axios
    .get(`${apiUrl}/manage-stock/get-material-type`)
    .then(async (res) => {
      if (Array.isArray(res.data)) {
        const stockTypes = res.data;

        // Fetch existing selling costs
        const sellingCostRes = await axios.get(`${apiUrl}/router-selling/all`);
        const sellingCostData = sellingCostRes.data;

        // Merge cost with stock types
        const merged = stockTypes.map((item) => {
          const matched = sellingCostData.find(
            (r) => r.materialType === item.materialType
          );
          return {
            _id: matched?._id || item.materialType, // use string ID if new
            materialType: item.materialType,
            sellingCost: matched?.sellingCost || 0,
            isNew: !matched, // flag to know if it's a new entry
          };
        });

        setRouterTypes(merged);
      } else {
        console.error("Unexpected response:", res.data);
      }
    })
    .catch((err) => {
      console.error("Error fetching router types:", err);
    });
}, []);



  const handleEdit = (id, currentCost) => {
    setEditId(id);
    setEditedCost(currentCost);
  };

// const handleSave = async (id) => {
//   const router = routerTypes.find((r) => r._id === id);
//   if (!router) return;

//   try {
//     const res = await axios.post(`${apiUrl}/router-selling/save-or-update`, {
//       materialType: router.materialType,
//       sellingCost: Number(editedCost),
//     });

//     toast.success("Selling cost saved!");

//     // update UI
//     setRouterTypes((prev) =>
//       prev.map((item) =>
//         item._id === id ? { ...item, sellingCost: Number(editedCost), isNew: false } : item
//       )
//     );
//     setEditId(null);
//     setEditedCost("");
//   } catch (error) {
//     console.error("Save failed", error);
//     toast.error("Failed to save");
//   }
// };
const handleSave = async (id) => {
  const router = routerTypes.find((r) => r._id === id);
  if (!router) return;

  // ❌ Validate the cost before sending
  if (!editedCost || isNaN(editedCost) || Number(editedCost) <= 0) {
    toast.error("Please enter a valid selling cost");
    return;
  }

  try {
    const res = await axios.post(`${apiUrl}/router-selling/save-or-update`, {
      materialType: router.materialType,
      sellingCost: Number(editedCost),
    });

    toast.success("Selling cost saved!");

    // update UI
    setRouterTypes((prev) =>
      prev.map((item) =>
        item._id === id ? { ...item, sellingCost: Number(editedCost), isNew: false } : item
      )
    );
    setEditId(null);
    setEditedCost("");
  } catch (error) {
    console.error("Save failed", error);
    toast.error("Failed to save");
  }
};



  const handleCancel = () => {
    setEditId(null);
    setEditedCost("");
  };

  return (
    <div className="router-container">
      <h2>Router Models & Selling Cost</h2>
      <div className="table-wrapper">
        <table className="responsive-table ">
          <thead className='table-th'>
            <tr>
              <th>Router Model</th>
              <th>Selling Cost (₹)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {routerTypes.map((router) => (
              <tr key={router._id}>
                <td>{router.materialType}</td>
                <td>
                  {editId === router._id ? (
                    <input
                      type="number"
                      value={editedCost}
                      onChange={(e) => setEditedCost(e.target.value)}
                    />
                  ) : (
                    `₹${router.sellingCost}`
                  )}
                </td>
                <td>
                  {editId === router._id ? (
                    <>
                      <button className="save-btn" onClick={() => handleSave(router._id)}>Save</button>
                      <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
                    </>
                  ) : (
                    <button className="edit-btn" onClick={() => handleEdit(router._id, router.sellingCost)}>
                    <MdModeEdit className="edit-icon" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {routerTypes.length === 0 && (
              <tr>
                <td colSpan="3">No data available</td>
              </tr>
            )}
            <ToastContainer position="top-right" autoClose={3000} />
          </tbody>
        </table>
      </div>
    </div>
  );
}
